const corpTransformer = (corp) => {
  return {
    corpCode: corp.sCorpCode,
    customFeatures: corp.customFeatures,
    name: corp.name,
    settings: corp.settings,
    token: corp.token
  };
};
export {
  corpTransformer
};
//# sourceMappingURL=Corp.mjs.map